import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { logError } from "@/lib/logger";
import { getAuthHeaders } from "@/lib/adminAuth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useBlogPosts() {
  const [posts, setPosts] = useState([]);

  const fetchPosts = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/blog?published_only=false`, { headers: getAuthHeaders() });
      setPosts(res.data);
    } catch (err) {
      logError("Failed to fetch posts", err);
    }
  }, []);

  useEffect(() => { fetchPosts(); }, [fetchPosts]);

  const savePost = async (form, editingId) => {
    try {
      if (editingId) {
        await axios.put(`${API}/blog/${editingId}`, form, { headers: getAuthHeaders() });
        toast.success("Post updated");
      } else {
        await axios.post(`${API}/blog`, form, { headers: getAuthHeaders() });
        toast.success("Post created");
      }
      fetchPosts();
      return true;
    } catch (err) {
      logError("Failed to save post", err);
      toast.error("Failed to save post");
      return false;
    }
  };

  const deletePost = async (id) => {
    try {
      await axios.delete(`${API}/blog/${id}`, { headers: getAuthHeaders() });
      toast.success("Post deleted");
      fetchPosts();
    } catch (err) {
      logError("Failed to delete post", err);
      toast.error("Failed to delete");
    }
  };

  const togglePublish = async (post) => {
    try {
      await axios.put(`${API}/blog/${post.id}`, { published: !post.published }, { headers: getAuthHeaders() });
      toast.success(post.published ? "Post unpublished" : "Post published");
      fetchPosts();
    } catch (err) {
      logError("Failed to toggle publish state", err);
      toast.error("Failed to update");
    }
  };

  return { posts, savePost, deletePost, togglePublish };
}
